import { useState } from 'react';

import type { OrderDetailsOrder } from '@/types/orderDetailsOrder';

import type { PaymentMethod } from '@/lib/payment/types';
import type { WithdrawalEligibility } from '@/lib/withdrawal/types';
import { OrderDetailsView } from '@/views/OrderDetailsView/OrderDetailsView';

type GuestDetailsViewMode = 'order' | 'return';

/** Guest order details: same `OrderDetailsView` as registered users; with `guestLookup`, eligibility reCAPTCHA + API run first, then UI matches. */
export type GuestOrderDetailsViewProps = {
  guestLookup: { businessId: string; email: string } | null;
  onEligibilityChange?: (eligibility: WithdrawalEligibility | null) => void;
  onStartReturn: () => void;
  order: OrderDetailsOrder;
  paymentMethod: PaymentMethod[] | PaymentMethod;
  withdrawalEligibility: WithdrawalEligibility | null;
};

export const GuestOrderDetailsView = ({
  guestLookup,
  onEligibilityChange,
  onStartReturn,
  order,
  paymentMethod,
  withdrawalEligibility,
}: GuestOrderDetailsViewProps) => {
  const [viewMode, setViewMode] = useState<GuestDetailsViewMode>('order');
  const [selectedReturnFulfillmentId, setSelectedReturnFulfillmentId] =
    useState<string | null>(null);

  const isReturnView =
    viewMode === 'return' && selectedReturnFulfillmentId != null;

  return (
    <OrderDetailsView
      guestSession={{
        eligibility: withdrawalEligibility,
        guestLookup,
        onEligibilityChange,
        onStartReturn,
        onViewOriginalOrder: () => {
          setViewMode('order');
          setSelectedReturnFulfillmentId(null);
        },
        onGuestViewReturnDetails: (fulfillmentId) => {
          setViewMode('return');
          setSelectedReturnFulfillmentId(fulfillmentId);
        },
      }}
      order={order}
      paymentMethod={paymentMethod}
      returnOrderId={isReturnView ? selectedReturnFulfillmentId : undefined}
      type={isReturnView ? 'RETURNHISTORY' : 'ORDERHISTORY'}
    />
  );
};
